import type { FormSubmission } from '@/types/cgt'
import type { AuditTrailRow } from '@/types/audit'

/** A run's submission as `GET /form-submissions` returns it, form name included. */
export type RunSubmission = FormSubmission & { formDefinition?: { name: string } | null }

export interface AuditFormGroup {
  submissionId: string
  formName: string
  status: FormSubmission['status']
  isAdHoc: boolean
  createdAt: string
  /** Newest change first, as the form-level trail shows them. */
  entries: AuditTrailRow[]
}

/**
 * A run's audit trail, form by form.
 *
 * Forms are ordered by when they were opened, which follows the order the run
 * was worked; each form's own rows stay newest first. Every form is listed,
 * including one with no changes yet, so the trail also shows which forms exist.
 */
export function groupAuditByForm(submissions: RunSubmission[], trails: AuditTrailRow[][]): AuditFormGroup[] {
  return submissions
    .map((sub, i) => ({
      submissionId: sub.id,
      formName: sub.formDefinition?.name ?? 'Form',
      status: sub.status,
      isAdHoc: sub.isAdHoc === true,
      createdAt: sub.createdAt,
      entries: [...(trails[i] ?? [])].sort((a, b) => b.changedAt.localeCompare(a.changedAt)),
    }))
    .sort((a, b) => a.createdAt.localeCompare(b.createdAt) || a.submissionId.localeCompare(b.submissionId))
}
